import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { CalendarOptions, EventClickArg } from '@fullcalendar/angular';

import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { CoreConfigService } from '@core/services/config.service';
import { EventsService } from './events.service';
import enGbLocale from '@fullcalendar/core/locales/es';
import { LandingService } from '../landing.service';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { Event } from '../../../../models/event.model';
import { environment } from 'environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss', '../stylesGlobLanding.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EventsComponent implements OnInit {
  url = environment.URL_AWS;
  public slideoutShow = false;
  public events = [];
  public event;
  @ViewChild("modalVC") modal;
  public eventModel: Event;

  public eventsPast: any[] = [];
  public eventsFuture: any[] = [];

  domainPage: string;
  paginatedFutureEvents: any[] = [];
  paginatedPastEvents: any[] = [];

  currentPage: number = 1;
  pageSize: number = 3; 

  currentPage2: number = 1;
  pageSize2: number = 3; 
  
  public calendarOptions: CalendarOptions = {
    headerToolbar: {
      start: 'prev,next, title',
      end: 'dayGridMonth,timeGridWeek,timeGridDay'
    },
    initialView: 'dayGridMonth',
    initialEvents: this.events,
    weekends: true,
    editable: true,
    eventResizableFromStart: true,
    selectable: true,
    selectMirror: true,
    dayMaxEvents: false,
    navLinks: true,
    eventClick: this.handleUpdateEventClick.bind(this),
    eventClassNames: this.eventClass.bind(this),
    select: this.handleDateSelect.bind(this),
    locale: enGbLocale,
  };

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreSidebarService} _coreSidebarService
   * @param {EventsService} _calendarService
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(private _router: Router,
    private _coreSidebarService: CoreSidebarService,
    private _eventsService: EventsService,
    private _coreConfigService: CoreConfigService,
    private _landingService: LandingService,
    private modalService: NgbModal) {
    this._unsubscribeAll = new Subject();

    var host = window.location.host;
    const domain = host.split('.')[1];
    let data;
    if (domain == 'ampi') {
      this.domainPage = host.split('.')[0];

    } else {
      this.domainPage = window.location.host;
    }
  }

  // Public Methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Add Event Class
   *
   * @param events
   */
  eventClass(s) {
    const calendarsColor = {
      Próximos: 'warning',
      Pasados: 'info',
      Actuales: 'primary',
    };

    const colorName = calendarsColor[s.event._def.extendedProps.eventType];
    return `bg-light-${colorName}`;
  }

  /**
   * Update Event
   *
   * @param event
   */
  handleUpdateEventClick(event: EventClickArg) {
    this.eventModel = this.events.find(x => x.id === parseInt(event.event._def.publicId, 10));
    console.log(this.eventModel);
    this.modalService.open(this.modal, {
      centered: true,
      size: 'lg'
    });
  }

  handleUpdateEventClick2(id:any) {
    this.eventModel = this.events.find(x => x.id === parseInt(id, 10));
    console.log(this.eventModel);
    this.modalService.open(this.modal, {
      centered: true,
      size: 'lg'
    });
  }


  /**
   * Toggle the sidebar
   *
   * @param name
   */
  toggleSidebar(name): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  /**
   * Date select Event
   *
   * @param event
   */
  handleDateSelect(event) {
    console.log("hola");
    /*const newEvent = new Event();
    newEvent.start = event.start;
    this._coreSidebarService.getSidebarRegistry('calendar-event-sidebar').toggleOpen();
    this._eventsService.onCurrentEventChange.next(newEvent);*/
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // this.domainPage = 'sanluispotosi';
    // Subscribe config change
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this._eventsService.onEventChange.subscribe(res => {
        this.calendarOptions.events = res;
      });
    });

    this._eventsService.onCurrentEventChange.subscribe(res => {
      this.event = res;
    });
    this._landingService.getServer('getEvents', this.domainPage).then(
      (resp: any[]) => {
        this.slideoutShow = false;
        this.events = resp;
        this.eventsPast = resp.filter(x => x['pastEvent'] === true);
        this.eventsFuture = resp.filter(x => x['pastEvent'] === false);
        this.getPageData();
        this.getPageData2();
        console.log("estos son los eventos",this.events);
        this.calendarOptions.events = resp;

      }, (error: any) => {

        console.log(error);
      }
    );
  }

  getPageData(): void {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    this.paginatedFutureEvents = this.eventsFuture.slice(startIndex, startIndex + this.pageSize);
  }

  goToPage(page: number): void {
    this.currentPage = page;
    this.getPageData();
  }

  getPageData2(): void {
    const startIndex = (this.currentPage2 - 1) * this.pageSize;
    this.paginatedPastEvents = this.eventsPast.slice(startIndex, startIndex + this.pageSize);
  }

  goToPage2(page: number): void {
    this.currentPage2 = page;
    this.getPageData2();
  }

  redirectEventLink(link: string) {
    window.open(link, '_blank');
  }

  /**
   * Calendar's custom button on click toggle sidebar
   */
  ngAfterViewInit() {
    // Store this to _this as we need it on click event to call toggleSidebar
    let _this = this;
    this.calendarOptions.customButtons = {
      sidebarToggle: {
        text: '',
        click() {
          _this.toggleSidebar('calendar-main-sidebar');
        }
      }
    };

    setTimeout(() => {
      var cols = document.getElementsByClassName('fc-dayGridMonth-button');
      for (let i = 0; i < cols.length; i++) {
        cols[i].setAttribute('style', 'border-radius: 40px 0px 0px 40px');
      }

      var cols = document.getElementsByClassName('fc-timeGridDay-button');
      for (let i = 0; i < cols.length; i++) {
        cols[i].setAttribute('style', 'border-radius: 0px 40px 40px 0px');
      }

      var cols = document.getElementsByClassName('fc-prev-button');
      for (let i = 0; i < cols.length; i++) {
        cols[i].setAttribute('style', 'border-radius: 40px 0px 0px 40px');
      }

      var cols = document.getElementsByClassName('fc--button');
      for (let i = 0; i < cols.length; i++) {
        cols[i].setAttribute('style', 'border-radius: 0px 40px 40px 0px');
      }



    }, 500);
  }

  storeEvents(id: number): void {

    if (id === 0) {
      this._router.navigateByUrl('events/store');
    } else {
      this._router.navigateByUrl('events/store/' + id);
    }

    /*this.alerta('error','No cuenta con el permiso de agregar cotizaciones','Para más información comunicarse con la central.');*/
  }
  
  public swiperResponsive: SwiperConfigInterface = {
    grabCursor: true,
    slidesPerView: 3,
    spaceBetween: 50,

    // init: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: true,
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 40
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      }
    },
  };

  filter($event: any): void {
    let filteredEvents = [];
    for (let e of this.events) {
      let checked = $event.filter(x => x.filter === e.eventType);
      console.log(checked, "checked");
      if (checked[0].checked == true) {
        filteredEvents.push(e);
      }
    }
    this.calendarOptions.events = filteredEvents;
    console.log($event, filteredEvents);
  }

}
